define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/resolver",
	"csi/middleware/rollup/rollupService",
	"csi/util",
	"csi/xml"
], function (declare, lang, when, resolver, { evaluate }, util, xml) {

	return declare(null, {
		m_name: null,

		// String: used to override type of actual view
		// FIX: why is this needed for manual export?
		m_typeView: null,

		/** @property {Record<string, any>} viewParams - parameters to apply to view */
		viewParams: null,

		constructor: function (def) {
			this.m_id = util.getProperty(def, 'Id');
			this.m_path = util.getProperty(def, 'Path');
			this.m_url = util.getProperty(def, 'URL');
		},

		isValid: function () {
			return !!this.m_id;
		},

		getReferencedClass: function (/*Class*/rc, /*Node?*/node) {
			// summary: determine class on which referenced view resides
			var url;

			// if url is not valid, try evaluating as expression
			if (this.m_url) {
				url = xml.isValidURL(this.m_url) ? this.m_url : evaluate(this.m_url, node, resolver.m_cache);
			}

			return resolver.resolveClass(rc, node, url, this.m_path);
		},

		getReferencedNode: function (/*Cache*/cache, /*Node*/node) {
			// summary: find referenced view in given context
			if (this.m_url) {
				var url = xml.isValidURL(this.m_url) ? this.m_url : evaluate(this.m_url, node, cache);
				node = resolver.resolveNode(url, true, cache);
			}

			return cache.getPathNode(node, this.m_path, true);
		},

		getValidURL: function () {
			// summary: return url if constant as opposed to expression
			return xml.isValidURL(this.m_url) ? this.m_url : null;
		}
	});
});